export default __webpack_public_path__ + "static/media/files-icon.20196db5.svg";